<template>
    
    <div class="w-full flex flex-col justify-between items-center text-xs lg:text-lg rounded bg-green-200 text-black">

        <div class="flex w-full justify-around h-10">

            <div class="flex flex-col">

                <div>

                    <label>{{$t('pitch.pitch')}}</label>
                </div>

                <div class="bg-blue-600 text-white">
                    
                    <label>{{booking.two_pitch_slot.two_pitch.name}}</label>
                </div>
            </div>

            <div class="flex flex-col">

                <div>

                    <label>{{$t('slot.startTime')}}</label>
                </div>

                <div class="bg-blue-600 text-white">
                    
                    <label>{{startTime}}</label>
                </div>
            </div>

            <div class="flex flex-col">

                <div>
                    
                    <label>{{$t('slot.endTime')}}</label>
                </div>

                <div class="bg-blue-600 text-white">

                    <label>{{endTime}}</label>
                </div>
            </div>

            <div class="flex flex-col">

                <div>

                    <label>{{$t('sessions.date')}}</label>
                </div>

                <div class="bg-blue-600 text-white">

                    <label>{{booking.day_date}}</label>
                </div>
            </div>
        </div>
        <div class="flex itemse-center justify-around w-full">

            <div class="justify-center">

                <button @click="callOpenMap"
                class="w-16 ms-2 h-8 lg:h-12 lg:ml-10 lg:rounded-lg rounded bg-blue-400 text-white text-sm
                lg:text-lg font-bold
                uppercase border-blue-500 border text-center">
                <label>{{$t('sessions.map')}}</label></button>
            </div>

            <div v-if="player.id == group.main_player_id" class="mt-4">

                <label class="bg-pink-700"> {{$t("player.owner")}}</label>
            </div>

            <div v-else-if="didPay" class="mt-4">

                <label class="bg-pink-600 p-1"> {{$t("player.paid")}}</label>
            </div>

            <div v-else-if="!isPending">
                
                <!-- <label class="bg-yellow-500"> {{$t("player.pay")}}</label> -->
                <player-group-booking-payment :player="player" :booking="booking" :group="group" :reload="reload"/>
            </div>

            <div else>

                <label class="bg-yellow-٦00"> {{$t("player.pending")}}</label>
            </div>
        </div>
  </div>
</template>

<script>

import playerGroupBookingPayment from './PlayersGroupBookingPayment'

import moment from 'moment'

export default {

    mounted(){

        // console.log(`this.booking: ${JSON.stringify(this.booking)}`)
        if(this.booking.two_player_to_player_transactions.length > 0){

            this.didPay  = true;
        }
    },

    props:{

        player: {
            type: Object
        },

        reload:{

          type: Function  
        },

        group: {

            type: Object
        },

        booking: {

            type: Object
        },

        openMap:{

            type: Function
        }
    },

    components:{

        playerGroupBookingPayment
    },

    computed:{

        isPending(){

            const timeNow = moment(new Date()).add('12','hours');

            const momentStartTime = moment(this.booking.start_time, 'HH:mm:ss');

            if(moment(this.booking.day_date).isSame(this.todayDate)){

                if(moment(timeNow).isSameOrAfter(momentStartTime)){
        
                    // console.log(`moment(timeNow).isSameOrAfter(startTime)`);
        
                    return false;
                }
                else{
                    
                    // console.log(`just else`);

                    return true;
                }
            }else if(moment(this.booking.day_date).isAfter(this.todayDate)){

                return true;
            }else{

                //to do
                return true;
            }
        }
    },

    methods:{

        callOpenMap(){

            this.openMap(this.booking.two_pitch_slot.two_pitch.location);
        }
    },

    data:function(){

        return{

            didPay: false,
            startTime: moment(new Date(`1970/01/01 ${this.booking.start_time}`)).format('hh:mm A'),
            endTime: moment(new Date(`1970/01/01 ${this.booking.end_time}`)).format('hh:mm A'),
            todayDate: moment(new Date()).format(moment.HTML5_FMT.DATE)
        }
    }
}
</script>

<style>

</style>